import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { persistor } from '../../../store/store';
import { setAclLoaded, setAclLoading } from '../../../store/reducers/aclSlice';
import useTranslation from '../../../Hooks/useTranslation';
import useNotification from '../../../Hooks/useNotification.hook';
import { MZCR_REFRESH_ACL_URL } from '../Utils/mzcrUrls';

/**
 * After the workplace certificate was uploaded user-api grants `patient_health_mzcr`. The PHP
 * session ACL is refreshed first (it decides the left menu and the access to Dočasné úložiště),
 * then the React ACL is invalidated and the page reloaded, so the menu is drawn with the new
 * permissions.
 */
export default function useRefreshMzcrAcl() {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const { showNotificationAlert } = useNotification();

	return useCallback(async () => {
		try {
			const response = await fetch(MZCR_REFRESH_ACL_URL, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
			});
			const body = response.ok ? await response.json() : null;
			if (!body?.refreshed) {
				throw new Error(`ACL refresh failed (${response.status})`);
			}
		} catch (e) {
			console.error(e);
			showNotificationAlert({
				content: t('component.mzcr.aclRefreshFailed'),
			});
			return;
		}

		dispatch(setAclLoading(false));
		dispatch(setAclLoaded(false));
		// The ACL is persisted - without the flush the reload could still read the old one
		await persistor.flush();
		window.location.reload();
	}, [dispatch, showNotificationAlert, t]);
}
